module.exports = __webpack_public_path__ + "img/textBtm1.02124518.png";